import Vue from 'vue'
import Vuex from 'vuex'
import incomeStatementModule from './modules/incomeStatement'
import integrationWithNip from './modules/integrationWithNip'
import statisticFromStatus from './modules/statisticFromStatus'
import budget from './modules/budget'


Vue.use(Vuex)

export default new Vuex.Store({
	actions: {
		changeSpinning(context, value) {
			context.commit('updateSpinning', value)
		},
		resizeWindow() {
			BX24.resizeWindow(
				parseInt($("body #root_block").css("width")),
				parseInt($("body #root_block").css("height"))
			);
		},
		getAuth(context) {
			context.commit('setAuth', BX24.getAuth())
		}
	},
	mutations: {
		setAuth(state, auth) {
			state.auth = auth
		},
		updateSpinning(state, value) {
			if (typeof value == 'boolean') {
				state.spinning = value;
			} else {
				state.spinning = !state.spinning
			}
		}
	},
	state: {
		auth: {},
		spinning: false
	},
	getters: {
		Auth(state) {
			return state.auth
		}
	},
	modules: { incomeStatementModule, integrationWithNip, statisticFromStatus, budget },
})
